module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainWork"
  }, [_c('div', {
    staticClass: "myMenu",
    staticStyle: {
      "position": "unset"
    }
  }, [_c('div', {
    staticClass: "priority"
  }, [_vm._v("执法管理")]), _vm._v(" "), (_vm.command == '超级管理员' || _vm.command == '高级管理员') ? _c('div', {
    on: {
      "click": _vm.personList
    }
  }, [_vm._v("人员管理")]) : _vm._e(), _vm._v(" "), (_vm.command == '超级管理员' || _vm.command == '高级管理员') ? _c('div', {
    on: {
      "click": _vm.unitList
    }
  }, [_vm._v("单位管理")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "formBox"
  }, [_c('el-form', {
    ref: "myForm",
    attrs: {
      "model": _vm.query,
      "size": "small"
    }
  }, [_c('span', {
    staticClass: "formBoxItem"
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "执法编号",
      "prop": "recordNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.recordNo),
      callback: function($$v) {
        _vm.$set(_vm.query, "recordNo", $$v)
      },
      expression: "query.recordNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "联系方式",
      "prop": "telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.telephone),
      callback: function($$v) {
        _vm.$set(_vm.query, "telephone", $$v)
      },
      expression: "query.telephone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "当事人",
      "prop": "partyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.partyName),
      callback: function($$v) {
        _vm.$set(_vm.query, "partyName", $$v)
      },
      expression: "query.partyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "车牌号",
      "prop": "carPlate"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.carPlate),
      callback: function($$v) {
        _vm.$set(_vm.query, "carPlate", $$v)
      },
      expression: "query.carPlate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px",
      "label": "驾驶证号",
      "prop": "cardCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.query.cardCode),
      callback: function($$v) {
        _vm.$set(_vm.query, "cardCode", $$v)
      },
      expression: "query.cardCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getAccidentList
    }
  }, [_vm._v("查询")])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.accidentList,
      "max-height": "460",
      "border": "",
      "tooltip-effect": "dark",
      "header-cell-style": _vm.tableHeaderColor,
      "cell-style": _vm.cellStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "执法编号",
      "show-overflow-tooltip": "",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.recordNo) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "执法位置",
      "show-overflow-tooltip": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.location) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "show-overflow-tooltip": "",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.partyName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当事人手机号",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.telephone) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "车牌号",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.carPlate) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驾驶证号",
      "show-overflow-tooltip": "",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.cardCode) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "show-overflow-tooltip": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(_vm._f("orderListFilter")(scope.row.status)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "执法人",
      "show-overflow-tooltip": "",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.realName) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "执法时间",
      "show-overflow-tooltip": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.createTime) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "取消原因",
      "show-overflow-tooltip": "",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.cancelReason) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status < 3) ? [_c('span', {
          staticClass: "reMessage",
          on: {
            "click": function($event) {
              return _vm.onQzhifa(scope.row)
            }
          }
        }, [_vm._v("取消执法")]), _vm._v(" "), _c('span', {
          on: {
            "click": function($event) {
              return _vm.getRoomId(scope.row.id, '', '')
            }
          }
        }, [_vm._v("进入处理")])] : [_c('span', {
          staticStyle: {
            "padding-left": "20px"
          },
          on: {
            "click": function($event) {
              return _vm.getRoomId(scope.row.id, '', '')
            }
          }
        }, [_vm._v("详情")])]]
      }
    }])
  })], 1), _vm._v(" "), (_vm.accidentList.length) ? _c('div', {
    staticClass: "pagination"
  }, [_c('nt-pagination', {
    ref: "child",
    on: {
      "fetchData": _vm.getMyAccidentList
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', [(_vm.AddAffairShow) ? _c('videoPlat', {
    ref: "videoPlat",
    attrs: {
      "roomId": _vm.roomId,
      "videoDirect": _vm.videoDirect,
      "videoSource": _vm.videoSource
    },
    on: {
      "reStartMask": _vm.reStartMask,
      "closeMask": _vm.closeMask,
      "startMethod": _vm.startMethod
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消执法原因",
      "center": "",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "dialogForm",
    attrs: {
      "model": _vm.dialogModel,
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "reason"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择取消执法类型"
    },
    model: {
      value: (_vm.dialogModel.reason),
      callback: function($$v) {
        _vm.$set(_vm.dialogModel, "reason", $$v)
      },
      expression: "dialogModel.reason"
    }
  }, _vm._l((_vm.typeLists), function(item) {
    return _c('el-option', {
      key: ("" + (item.id)),
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写取消执法原因",
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.dialogModel.remark),
      callback: function($$v) {
        _vm.$set(_vm.dialogModel, "remark", $$v)
      },
      expression: "dialogModel.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b7d11ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhiFa/workPlat.vue
// module id = HKf0
// module chunks = 4